"use client";

import { LoadingWrapper } from "@packages/ui";
import { useRouter } from "next/navigation";
import { Fragment, useEffect } from "react";

interface BibleBookRedirectProps {
  translation: string;
  firstBookId: string;
}

export const BibleBookRedirect = ({
  translation,
  firstBookId,
}: BibleBookRedirectProps) => {
  const router = useRouter();

  useEffect(() => {
    router.replace(`/bible/${translation}/${firstBookId}/1`);
  }, [translation, firstBookId, router]);

  return (
    <LoadingWrapper isLoading={true}>
      <Fragment />
    </LoadingWrapper>
  );
};
